import { MAX_SAVED_FILE_NAME_LENGTH, shortenFileName } from "./fileNameLength";

const LIBRARY_PREFIX = "Diligent-";

// The name a downloaded VQQ export is saved under. A stored VQQ name carries the request's due
// date, so VQQ rows use the file name the export returned, which carries the release date. Library
// rows keep their own "Diligent-{document}-{requested on}" convention, with the document name
// shortened so the whole name stays within the limit.
export const exportSaveName = ({ isDocLibrary, details, exportFileName }) => {
  if (!isDocLibrary) return exportFileName || shortenFileName(details?.name);

  const requestedOn = `-${details?.requested_on}`;
  const room = MAX_SAVED_FILE_NAME_LENGTH - LIBRARY_PREFIX.length - requestedOn.length;
  return `${LIBRARY_PREFIX}${shortenFileName(details?.document_name, room)}${requestedOn}`;
};
